// extracted by mini-css-extract-plugin
export default {"zoomControls":"Wca-z","zoomControlButton":"Xca-z","zoomBanner":"Yca-z","bannerButton":"Zca-z","imageButton":"_ca-z","zoom":"ada-z","zoomContent":"bda-z"};